import { AddToCalendarButton } from 'add-to-calendar-button-react';
import { format } from 'date-fns';
import React from 'react';
import { useEventContext } from '../../context/EventProvider';
import useEventDetails from '../../hooks/useEventDetails';

const AddToCal = () => {
  const {
    event: { title, timezone, addresses }
  } = useEventContext();
  const { location } = addresses[0];
  const { eventStartTime, eventEndTime } = useEventDetails();
  const startDate = new Date(eventStartTime);
  const endDate = new Date(eventEndTime);

  return (
    <AddToCalendarButton
      startTime={format(startDate, 'HH:mm')}
      endTime={format(endDate, 'HH:mm')}
      startDate={format(startDate, 'yyyy-MM-dd')}
      endDate={format(endDate, 'yyyy-MM-dd')}
      name={title}
      options={['Apple', 'Google', 'Outlook.com', 'iCal']}
      location={location}
      timeZone={timezone}
    />
  );
};

export default AddToCal;
